import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import DropZone from "./Dropzone";
import Images from "../../Images";
import { toast } from "react-toastify";

const UploadCancelModel = ({
  uploadCancelLoading,
  postUploadCancel,
  setOpenCancelModel,
  selectedItem,
}) => {
  const [certificate, setCertificate] = useState("");

  const InitialValues = {
    id: selectedItem?.id,
    status: 6,
    certificate: "",
  };

  // console.log(selectedItem);

  const SubmitHandler = (values) => {
    if (certificate == '')
      return toast.error("Please upload document");
      postUploadCancel({ fileName: certificate, appId: selectedItem?.id, });
  };

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setOpenCancelModel}>
      <Title>Upload Cancellation Docs</Title>

      {uploadCancelLoading && <Loading />}

      {!uploadCancelLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <InputGroup>
                    <Label htmlFor="certificate">
                      Please upload cancellation Ducument
                    </Label>
                    <DropZone setUploadFile={setCertificate} required/>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit" disabled={!certificate}>Upload</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

export default UploadCancelModel;
